import React, { FC } from 'react'
import { ModalComponent } from 'Pages/landings/common/components/Modal'
import { Callback } from 'Pages/landings/common/types'
import { OutLinks } from 'Pages/landings/common/constants'
import './style.scss'

interface ComponentProps {
	message: {
		showMessage: boolean
		title: string
		subTitle: string
		typeMessage: string
		isClient: boolean
		partnerRequestId: string
	}
	revertShowForm?: Callback
	seconds?: number
	partnerID?: string
	requestId?: string
	utmSource?: string
	transactionId?: string
}

export const ModalMessageComponent: FC<ComponentProps> = ({
	message: { title, subTitle, typeMessage, isClient, partnerRequestId },
	revertShowForm,
	seconds,
	partnerID,
	requestId,
	utmSource,
	transactionId,
}) => {
	const className = {
		modal: 'modal-form',
		successMessage: 'landing-message_success',
		errorMessage: 'landing-message_error',
		buttonMessage: 'landing-message_button',
		close: 'landing-close',
		buttonBlack: 'landing-button-black',
		allWidth: 'landing-all-width',
	}

	const classMessage = typeMessage === 'success' ? className.successMessage : className.errorMessage

	const classNameButton = `${className.buttonBlack} ${className.allWidth}`

	let pixel
	if (typeMessage === 'success') {
		if (utmSource === 'workle' && requestId && partnerRequestId)
			pixel = OutLinks.pixel_workle
				.replace(':partnerId', requestId)
				.replace(':partnerRequestId', partnerRequestId)
		if (utmSource === 'leads.su' && transactionId && partnerRequestId) {
			pixel = OutLinks.pixel_rko.path_leads
				.replace(':transactionId', transactionId)
				.replace(':partnerRequestId', partnerRequestId)
		}
		if (partnerRequestId && partnerID === OutLinks.pixel_rko.partner_id)
			pixel = OutLinks.pixel_rko.path.replace(':id', partnerRequestId)
	}

	return (
		<>
			{pixel && <img src={pixel} width="1" height="1" alt="" />}
			<ModalComponent closeModal={revertShowForm}>
				<div className={`${classMessage}_title`}>{title}</div>
				<div className={`${classMessage}_sub-title`}>
					{subTitle}
					{typeMessage === 'success' && isClient && (
						<div>
							Для самостоятельного оформления заявки Вы будете перенаправлены в Сбербанк Бизнес
							онлайн через {seconds} секунд
						</div>
					)}
				</div>
				{typeMessage === 'error' && (
					<button className={classNameButton} onClick={revertShowForm}>
						Назад
					</button>
				)}
			</ModalComponent>
		</>
	)
}
